import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { BaseResponse } from '../../../shared/models/base-api-response.interface';
import { endpoint, httpOptions } from '../../../shared/apis/endpoint';
import { environment as env } from '../../../../environments/environment';
import { Cita } from '../models/cita.interface';

@Injectable({
  providedIn: 'root'
})
export class CitaService {

  constructor(
    private _http: HttpClient) { }

  ReservarCita(cita: Cita): Observable<BaseResponse> {
    const requestUrl = `${env.api}${endpoint.CITA_ADD}`
    return this._http.post(requestUrl, cita, httpOptions).pipe(
      map((resp: any) => resp as BaseResponse)
    )
  }

  ConfirmarCita(numero: number): Observable<BaseResponse> {
    const requestUrl = `${env.api}${endpoint.CITA_CONFIRM_WHATSAPP}${numero}`
    return this._http.put(requestUrl, httpOptions).pipe(
      map((resp: any) => resp as BaseResponse)
    )
  }

  CancelarCita(numero: number): Observable<BaseResponse> {
    const requestUrl = `${env.api}${endpoint.CITA_CENCEL_WHATSAPP}${numero}`
    return this._http.post(requestUrl, httpOptions).pipe(
      map((resp: any) => resp as BaseResponse)
    )
  }

  ReservaCitaTurnos(historia: number): Observable<BaseResponse> {
    const requestUrl = `${env.api}${endpoint.CITA_TURNOS}${historia}`
    return this._http.get(requestUrl).pipe(
      map((resp: any) => resp as BaseResponse)
    );
  }

  InformacionCitaTurnos(numero: number): Observable<BaseResponse> {
    const requestUrl = `${env.api}${endpoint.CITA_INFO}${numero}`
    return this._http.get(requestUrl).pipe(
      map((resp: any) => resp as BaseResponse)
    );
  }

  InformacionCitaWhatsapp(numero: number): Observable<BaseResponse> {
    const requestUrl = `${env.api}${endpoint.CITA_INFO_WHATSAPP}${numero}`
    return this._http.get(requestUrl).pipe(
      map((resp: any) => resp as BaseResponse)
    );
  }

  DeleteCita(numero: number): Observable<BaseResponse> {
    const requestUrl = `${env.api}${endpoint.CITA_DELETE}${numero}`
    return this._http.delete(requestUrl).pipe(
      map((resp: any) => resp as BaseResponse)
    );
  }

}
